var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatarUpload",attrs:{"action":_vm.imgUrl,"headers":_vm.myHeaders,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[(_vm.image)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.image}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }